import { getLocalStorageData } from '../../utils/helper';
import { APP_API_URL, APP_API_URL_V2 } from '../../utils/xhr-instance';
import axiosInstance, { axiosInstanceV2 } from '../axios';

export const INVENTORY_ADJUSTMENT_CREATE_DONE = 'INVENTORY_ADJUSTMENT_CREATE_DONE';
export const INVENTORY_ADJUSTMENT_CREATE_FAIL = 'INVENTORY_ADJUSTMENT_CREATE_FAIL';

export const INVENTORY_ADJUSTMENT_LIST_GET_DONE = 'INVENTORY_ADJUSTMENT_LIST_GET_DONE';
export const INVENTORY_ADJUSTMENT_LIST_GET_FAIL = 'INVENTORY_ADJUSTMENT_LIST_GET_FAIL';

export const REFERANCE_NUMBER_GET_DONE = 'REFERANCE_NUMBER_DONE';
export const REFERANCE_NUMBER_GET_FAIL = 'REFERANCE_NUMBER_FAIL';

export const INVENTORY_ADJUSTMENT_UPDATE_DONE = 'INVENTORY_ADJUSTMENT_UPDATE_DONE';
export const INVENTORY_ADJUSTMENT_UPDATE_FAIL = 'INVENTORY_ADJUSTMENT_UPDATE_FAIL';

export const INVENTORY_ADJUSTMENT_DELETE_DONE = 'INVENTORY_ADJUSTMENT_DELETE_DONE';
export const INVENTORY_ADJUSTMENT_DELETE_FAIL = 'INVENTORY_ADJUSTMENT_DELETE_FAIL';

export const INVENTORY_ADJUSTMENT_CONVERT_DONE = 'INVENTORY_ADJUSTMENT_CONVERT_DONE';
export const INVENTORY_ADJUSTMENT_CONVERT_FAIL = 'INVENTORY_ADJUSTMENT_CONVERT_FAIL';

export const INVENTORY_ADJUSTMENT_CREATE_API_URL = `${APP_API_URL}/product/inventory-adjustment`;
export const INVENTORY_ADJUSTMENT_LIST_API_URL = `${APP_API_URL}/product/inventory-adjustment/list`;

export const INVENTORY_ADJUSTMENT_ACCOUNTS_LIST_API_URL = `${APP_API_URL}/product/getAccounts`;
export const INVENTORY_ADJUSTMENT_REASON_LIST_API_URL = `${APP_API_URL}/product/getReasons`;

export const INVENTORY_ADJUSTMENT_UPDATE_API_URL = `${APP_API_URL}/product/inventory-adjustmtent/update`;
export const INVENTORY_ADJUSTMENT_DELETE_API_URL = `${APP_API_URL}/product/inventory-adjustment/delete`;
export const INVENTORY_ADJUSTMENT_CONVERT_API_URL = `${APP_API_URL}/product/inventory-adjustment/convert-to-adjustment`;
export const INVENTORY_ADJUSTMENT_REVERT_API_URL = `${APP_API_URL}/product/inventory-adjustment/revert-to-adjustment`;
export const REFERANCE_NUMBER_API_URL = `${APP_API_URL}/product/get-reference-number`;

let token = getLocalStorageData();
const config = {
	headers: {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token?.token}`,
	},
};

export const inventoryAdjustmentCreate = async (formBody) => {
	try {
		const API_URL = INVENTORY_ADJUSTMENT_CREATE_API_URL;
		const res = await axiosInstance.post(API_URL, formBody, config);

		if (res?.data?.success) {
			return res.data;
		} else {
			return res;
		}
	} catch (err) {
		console.error(err);
		return err;
	}
};
///  adjustment details api
export const fetchInventoryAdjustmentListForDetails = async (params) => {
	try {
		const API_URL = `${INVENTORY_ADJUSTMENT_LIST_API_URL}?${params}`;
		const token = getLocalStorageData();
		const { data } = await axiosInstance.get(API_URL, {
			headers: {
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return data;
	} catch (err) {
		throw err;
	}
};
export const fetchInventoryAdjustmentList = async (params) => {
	try {
		const API_URL = `${INVENTORY_ADJUSTMENT_LIST_API_URL}`;
		const token = getLocalStorageData();
		const { data } = await axiosInstance.get(API_URL, {
			params,
			headers: {
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return data;
	} catch (err) {
		throw err;
	}
};

export const inventoryAdjustmentUpdate = async (id, formBody) => {
	try {
		const API_URL = `${INVENTORY_ADJUSTMENT_UPDATE_API_URL}/${id}`;
		const res = await axiosInstance.put(API_URL, formBody, config);

		if (res?.data?.success) {
			return res.data;
		} else {
			return res;
		}
	} catch (err) {
		return err;
	}
};

export const inventoryAdjustmentDelete = async (id) => {
	try {
		const API_URL = `${INVENTORY_ADJUSTMENT_DELETE_API_URL}/${id}?is_delete=1`;
		const res = await axiosInstance.delete(API_URL, config);

		if (res?.data?.success) {
			return res.data;
		} else {
			return res;
		}
	} catch (err) {
		return err;
	}
};

export const inventoryAdjustmentConvert = async (id) => {
	try {
		const API_URL = `${INVENTORY_ADJUSTMENT_CONVERT_API_URL}/${id}`;
		const res = await axiosInstance.post(API_URL, {}, config);

		if (res?.data?.success) {
			return res.data;
		} else {
			return res;
		}
	} catch (err) {
		return err;
	}
};

export const inventoryAdjustmentReverted = async (id) => {
	try {
		const API_URL = `${INVENTORY_ADJUSTMENT_REVERT_API_URL}/${id}`;
		const res = await axiosInstance.post(API_URL, {}, config);

		if (res?.data?.success) {
			return res.data;
		} else {
			return res;
		}
	} catch (err) {
		return err;
	}
};

export const getRefNumber = async (param) => {
	try {
		let API_URL = REFERANCE_NUMBER_API_URL;
		if (param) {
			API_URL = `${REFERANCE_NUMBER_API_URL}?${param}`;
		}

		const res = await axiosInstance.get(API_URL, config);

		if (res?.data?.success) {
			return res.data;
		} else {
			return res;
		}
	} catch (err) {
		console.error(err);
		return err;
	}
};

export const fetchAdjustmentAccounts = async () => {
	try {
		const API_URL = `${INVENTORY_ADJUSTMENT_ACCOUNTS_LIST_API_URL}`;
		const token = getLocalStorageData();
		const res = await axiosInstance.get(API_URL, {
			headers: {
				Authorization: `Bearer ${token?.token}`,
			},
		});

		if (res?.data?.success) {
			return res.data;
		} else {
			return res;
		}
	} catch (err) {
		console.error(err);
		return err;
	}
};

export const fetchReasonList = async (param) => {
	try {
		const API_URL = `${INVENTORY_ADJUSTMENT_REASON_LIST_API_URL}`;
		const res = await axiosInstance.get(API_URL, config);

		if (res?.data?.success) {
			return res.data;
		} else {
			return res;
		}
	} catch (err) {
		console.error(err);
		return err;
	}
};

export async function generateInventoryAdjustmentPdf(id, merge = false) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/inventory/adjustments/generate-pdf?ids=${id}&merge=${merge}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.data.signed_urls[0];
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}
